export {default as Stack, } from "./Stack";
